import styled from "styled-components";
import { IconButton } from "../../atoms/IconButton";
import { Trigger as DropdownTrigger } from "../Dropdown/Dropdown.styles";
import { rawColors } from "../../../design-system/tokens/colors";
import { spacing } from "../../../design-system/tokens/spacing";
import { borderRadius } from "../../../design-system/tokens/borders";
import { controlSize } from "../../../design-system/tokens/controlSizes";
import { typographyMixin } from "../../../design-system/tokens/typography";

export const Card = styled.section`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  gap: ${spacing[3]};
  padding: ${spacing[2]} ${spacing[3]} ${spacing[3]};
  background-color: ${rawColors.structural.themeLight};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const Title = styled.h3`
  margin: 0;
  ${typographyMixin("caption", 2)}
  color: ${rawColors.text.highEmphasis};
`;

export const RemoveButton = styled(IconButton)`
  width: ${spacing[8]};
  height: ${spacing[8]};
  color: ${rawColors.accent.red500};

  &:hover:not(:disabled),
  &:active:not(:disabled) {
    color: ${rawColors.accent.red500};
  }
`;

export const Field = styled.div`
  display: flex;
  flex: 1 1 0;
  flex-direction: column;
  min-width: 0;
  gap: ${spacing[2]};
`;

export const FieldLabel = styled.label`
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
`;

export const DropdownField = styled.div`
  width: 100%;
  min-width: 0;

  ${DropdownTrigger} {
    padding: ${spacing[2]} ${spacing[3]} ${spacing[2]} ${spacing[4]};
    border-radius: ${borderRadius.lg};
  }
`;

export const MetricStatus = styled.p`
  display: flex;
  align-items: center;
  gap: ${spacing[2]};
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.interactive};
`;

export const ThresholdRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-items: start;
  width: 100%;
  gap: ${spacing[3]};
`;

export const ThresholdInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  height: ${controlSize.field.md};
  margin: 0;
  padding: ${spacing[2]} ${spacing[3]} ${spacing[2]} ${spacing[4]};
  appearance: none;
  background-color: ${rawColors.structural.white};
  border: 1px solid ${rawColors.stroke[200]};
  border-radius: ${borderRadius.lg};
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.highEmphasis};

  &::placeholder {
    color: ${rawColors.text.lowEmphasis};
  }

  &:focus,
  &:focus-visible {
    outline: none;
    border-color: ${rawColors.primary[500]};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const AutoHelperText = styled.p`
  margin: 0;
  ${typographyMixin("caption", 3)}
  color: ${rawColors.text.mediumEmphasis};
  font-style: italic;
`;
